import * as React from "react";

const NpWarning = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18">
            <g fill="none" fill-rule="evenodd">
                <g fill="#AC1E2D" fill-rule="nonzero">
                    <path d="M21.848 15.816L11.846.447C11.662.169 11.343 0 11 0c-.343 0-.662.17-.845.447L.152 15.816c-.195.3-.203.677-.021.985.182.306.524.493.892.484h20.005c.358-.009.684-.202.854-.506.169-.303.156-.671-.034-.963zm-9.823-1.412h-2v-1.92h2v1.92zm0-3.843h-2V5.76h2v4.802z" transform="translate(-366.000000, -370.000000) translate(366.000000, 370.000000)"/>
                </g>
            </g>
        </svg>
    );
};

export default NpWarning;